export let ProgressStatus = /*#__PURE__*/function (ProgressStatus) {
  ProgressStatus["IS_SUCCESS"] = "IS_SUCCESS";
  ProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
  ProgressStatus["NOT_STARTED"] = "NOT_STARTED";
  ProgressStatus["IS_ERROR"] = "IS_ERROR";
  return ProgressStatus;
}({});